export default __webpack_public_path__ + "static/media/file7.4093f74e.jpg";